import React from 'react'
import ToggleLabel from '@Components/Selectors/ToggleLabel'
import './index.scss'

interface SongwriterCatalogBuilderToggleProps {
    onClick: (isLinked: boolean) => void
    checked: boolean
    label?: string
    internalLabel?: string
}

const SongwriterCatalogBuilderToggle = (props: SongwriterCatalogBuilderToggleProps) => (
    <div className="songwriter-link-toggle">
        <ToggleLabel mainColor {...props} />
    </div>
)

export default SongwriterCatalogBuilderToggle
